import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

/** Header, status and the two columns while the offer loads. */
const OfferDetailSkeleton = () => (
  <Stack gap={3} aria-busy="true">
    <Skeleton variant="text" width="40%" height={40} />
    <Skeleton variant="rounded" height={56} />
    <Box
      sx={{
        display: 'grid',
        gap: 3,
        gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'minmax(0, 2fr) minmax(0, 1fr)' },
      }}
    >
      <Skeleton variant="rounded" height={280} />
      <Skeleton variant="rounded" height={360} />
    </Box>
  </Stack>
);

export default OfferDetailSkeleton;
